import { QueryKey } from '@tanstack/react-query';

export const referralsQueryKey: QueryKey = ['referrals'];

export const referralsQueryKeyFn = (code: string): QueryKey => referralsQueryKey.concat(['code', code]);
export const referralStatusesQueryKey: QueryKey = referralsQueryKey.concat(['currentUser']);
